import Icons from "/src/features/phone/data/types/Icons"
export default [
    {
        value: "web",
        text: <span> <img srcSet={Icons["web"]}></img></span>,
    },
    {
        
        value: "telephony",
        text : <span> <img srcSet={Icons["telephony"]}></img> </span>        
    },
    {
        
        value: "rcs",
        text : <span> <img srcSet={Icons["rcs"]}></img> </span>
    },
    {
        // Announced but not built yet: shown as disabled rather than hidden.
        value: "whatsapp",
        disabled: true,
        text : <span> <img srcSet={Icons["whatsapp"]}></img> <span className="channel_coming_soon">Coming soon</span> </span>
    },
]